import React from 'react'
import Button from "react-toolbox/lib/button/Button"
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import RadioButton from 'react-toolbox/lib/radio/RadioButton';
import RadioGroup from 'react-toolbox/lib/radio/RadioGroup';
import {bindActionCreators} from "redux";
import * as AppActions from "../../../actions/app";
import connect from "react-redux/es/connect/connect";


let value = null;

const handleChange = (_value) => {
    value = _value;
};

const PopupNotification = (props) => {
    return (
        <ThemeProvider theme={theme}>
            <div className="row">
                <div className="modal-content col-lg-2  col-sm-2 col-xs-12">
                    <p style={{"font-weight": "bold"}}>New data has been registered</p>
                    <div className="test">
                        <RadioGroup className="popupRadioGroup" name='comic' value={value} onChange={handleChange}>
                            <RadioButton className="popupRadioButton" label="Don't show this message again"
                                         value="0"/>
                        </RadioGroup>
                        <Button primary
                                onClick={() => {
                                    if (value === "0")
                                        props.appActions.disableNotification();
                                }}
                                label="update"/>
                    </div>
                </div>
            </div>
        </ThemeProvider>
    )
};

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(AppActions, dispatch)
    }
};

export default connect(null, mapDispatchToProps)(PopupNotification)


// WEBPACK FOOTER //
// ./src/components/Map/BettAppBar/PopupNotification.js